<div class="row">
  <div class="col-sm-12 div-spacer-red col-div-pitch1">
    <div class="main-pitch-text ">Interactive Math for Age 5 to 13 years</div>
    <div class="main-pitch-text2">Most Children can do math, but just forget after a few days. Support them to have fun and enjoy math.</div>
  </div>
</div>




<div class="row my-5">
  <div class="col-sm-12 justify-content-center align-self-center">
    <app-dream></app-dream>
    <app-free-download></app-free-download>
  </div>

</div>
<app-choose-country></app-choose-country>
  <div class="row div-spacer">
    <div class="col-sm-4 text-center">
      <app-level-info-display
          *ngIf="iData"
          [iData]="iData"
          [imageDescription]="imageSevenDescription"
          [syllabusCode]="'UG_p7mtc'"
          [gradeLevel]="7"
          [imageName]="'boldungu_usecase8_800x600.png'"></app-level-info-display>
        </div>
    <div class="col-sm-4 text-center">
      <app-level-info-display
          *ngIf="iData"
          [iData]="iData"
          [imageDescription]="imageSixDescription"
          [syllabusCode]="'UG_p6mtc'"
          [gradeLevel]="6"
          [imageName]="'boldungu_usecase1_800x600.png'"></app-level-info-display>
      </div>
      <div class="col-sm-4 text-center">
        <app-level-info-display
          *ngIf="iData"
          [iData]="iData"
          [imageDescription]="imageFiveDescription"
          [syllabusCode]="'UG_p5mtc'"
          [gradeLevel]="5"
          [imageName]="'boldungu_usecase12_800x600.png'"></app-level-info-display>
    </div>
  </div>

  <app-pitch-four></app-pitch-four>
  <app-free-access-to-pdf></app-free-access-to-pdf>

  <div class="row div-spacer">
    <div class="col-sm-4 text-center">
        <app-level-info-display
          *ngIf="iData"
          [iData]="iData"
          [imageDescription]="imageFourDescription"
          [syllabusCode]="'UG_p4mtc'"
          [gradeLevel]="4"
          [imageName]="'boldungu_usecase9_800x600.png'"></app-level-info-display>
    </div>
    <div class="col-sm-4 text-center">
        <app-level-info-display
          *ngIf="iData"
          [iData]="iData"
          [imageDescription]="imageThreeDescription"
          [syllabusCode]="'UG_p3mtc'"
          [gradeLevel]="3"
          [imageName]="'boldungu_usecase11_800x600.png'"></app-level-info-display>
    </div>
    <div class="col-sm-4 text-center">
        <app-weekly-package></app-weekly-package>
    </div>
  </div>

    <app-quote-one></app-quote-one>
    <div class="row div-spacer">
      <div class="col-sm-4 text-center">
        <app-level-info-display
        *ngIf="iData"
        [iData]="iData"
        [imageDescription]="imageTwoDescription"
        [syllabusCode]="'UG_p2mtc'"
        [gradeLevel]="2"
        [imageName]="'boldungu_usecase4_800x600.png'"></app-level-info-display>
      </div>
      <div class="col-sm-4 text-center">
        <app-level-info-display
          *ngIf="iData"
          [iData]="iData"
          [syllabusCode]="'UG_p1mtc'"
          [gradeLevel]="1"
          [imageName]="'boldungu_usecase10_800x600.png'"></app-level-info-display>
      </div>


      <div class="col-sm-4 text-center">
        <app-weekly-package></app-weekly-package>
      </div>
    </div>
    <app-pitch-three></app-pitch-three>
    <app-quote-two></app-quote-two>

    <app-feature></app-feature>
    <app-feature-two></app-feature-two>
    <div class="row my-5">
  <div class="col-sm-12 justify-content-center align-self-center">
<app-free-download></app-free-download>
  </div>
</div>
    <app-slide-show-nice></app-slide-show-nice>
    <div class="row my-5">
  <div class="col-sm-12 justify-content-center align-self-center">
<app-free-download></app-free-download>
  </div>
</div>
    <app-free-access-to-pdf></app-free-access-to-pdf>
    <app-country-level-syllabus></app-country-level-syllabus>

